import _axios from '../../index'
import qs from 'qs'
// 清理未读
export const mesClearUnread = (data) =>
    _axios({
        headers: {
            'content-type': "application/json;charset=UTF-8",
        },
        url: `/messenger/clearUnread`,
        method: 'put',
        data,
         stopLoading: true,
    })

// 消息列表
export const mesSearch = (data) =>
    _axios({
        url: '/messenger/search',
        method: 'get',
        params: data,
         stopLoading: true,

    })

// 查询当前用户通知授权
export const mesSearchNoticeGrant = (data) =>
    _axios({
        url: '/messenger/findNoticeGrantByUserId',
        method: 'get',
        params: data,
         stopLoading: true,

    })

// 获取未读消息数量
export const mesUnreadCount = (data) =>
    _axios({
        url: '/messenger/unreadCount',
        method: 'get',
        params: data,
        isToast: false,
         stopLoading: true,

    })

// 更新用户通知授权
export const mesUpdateNoticeGrant = (data) =>
    _axios({
        url: '/messenger/updateNoticeGrant',
        method: 'put',
        data,
         stopLoading: true,

    })
